import { render, staticRenderFns } from "./QuestionSlide.vue?vue&type=template&id=406ef43b&scoped=true&"
import script from "./QuestionSlide.vue?vue&type=script&lang=js&"
export * from "./QuestionSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSlide.vue?vue&type=style&index=0&id=406ef43b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ef43b",
  null
  
)

export default component.exports